module.exports = __webpack_public_path__ + "static/media/gallery_06.998fe609.png";